import { useTranslation } from 'react-i18next';
import { Icon, Typography, Button } from '@/components';
import { isItemNull } from '@/features/projects/helpers';
import { useCountries } from '@/hooks';

export type TopcoBoxProps = {
  readonly normalizedProject: any;
  readonly onEdit?: () => void;
  readonly isEditable: boolean;
};

export function TopcoBox({ normalizedProject, isEditable, onEdit }: TopcoBoxProps) {
  const { t } = useTranslation(['opportunities']);
  const topcoTech = normalizedProject.technologies.find((tech: any) => tech.type === 'topco');
  if (!topcoTech) return null;
  const { kv } = useCountries();

  const item = topcoTech.details.item;
  if (!isEditable && isItemNull(item)) return null;

  const fields = [
    {
      label: t('HQ Location'),
      value: item.hqLocation ? kv[item.hqLocation] : null,
    },
    {
      label: t('Company Type'),
      value: item.companyType,
    },
    {
      label: t('Other Details'),
      value: item.otherDetails,
    },
  ];

  const visibleFields = isEditable
    ? fields
    : fields.filter(({ value }) => value !== null && value !== undefined && value !== '');

  return (
    <div className="rounded-lg border border-neutral-50 bg-white p-6 shadow-xs">
      <div className="mb-6 flex items-center">
        <div className="flex grow items-center">
          <div className="mr-2 flex h-10 w-10 items-center justify-center rounded-full bg-neutral-50">
            <Icon name="topco" className="h-6 w-6" />
          </div>
          <Typography as="h3" weight="semibold" size="title">
            {t('TopCo Details & Design')}
          </Typography>
        </div>
        {isEditable && (
          <Button size="sm" color="neutral" icon="edit" onClick={onEdit} className="ml-auto">
            {t('Edit')}
          </Button>
        )}
      </div>

      <div className="grid grid-cols-1">
        {visibleFields.map(({ label, value }) => (
          <Typography key={label} as="p" size="body-2" weight="semibold" relaxed className="mb-1">
            {label}:{' '}
            <span className="ml-3 text-base font-normal text-neutral-900">{value ?? (isEditable ? '—' : null)}</span>
          </Typography>
        ))}
      </div>
    </div>
  );
}
